import { Subsection } from '@fourthwall/components';
import { UpgradeSubscriptionBanner, useSubscription, } from '@modules/Dashboard/modules/Subscriptions';
import React from 'react';
export const ClaimDomain = () => {
    const { hasActiveSubscription } = useSubscription();
    return (React.createElement(Subsection, { title: "Claim free domain with Fourthwall Pro" }, !hasActiveSubscription && (React.createElement(UpgradeSubscriptionBanner, null, "Upgrade to Fourthwall Pro and claim your free custom domain plus unlock dozens of powerful perks."))));
};
